<template>
    <div style="display:flex">
        <youtube :video-id="videoId" ref="youtube" style="margin: auto" :width="700"></youtube>
    </div>
</template>
<script>

export default {
  props: ['model'],
  computed: {
    videoId: function() { return this.$youtube.getIdFromUrl(this.model.content) }
  }
}
</script>
